import * as React from 'react';
import { YouTube } from '../YouTube/YouTube';
import { VideoFigure } from './VideoFigure';
import type { VideoFigureViewModel } from './VideoFigureViewModel.csharp';

export const YouTubeVideoFigure: React.FC<VideoFigureViewModel> = props => {
    const { caption, videoId } = props;

    return <VideoFigure caption={caption}>{() => <YouTube videoId={videoId} title={caption} />}</VideoFigure>;
};
